import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '需求概述',
    type: 'BRF_OVERVIEW',
    mapProp: 'map',
}
